import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { FadeUp, RevealMaskScroll } from "../components/Reveal";
import { ArrowRight } from "lucide-react";

export default function Collections() {
  const [categories, setCategories] = useState([]);
  const [occasions, setOccasions] = useState([]);

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(r.data));
    api.get("/occasions").then((r) => setOccasions(r.data));
  }, []);

  return (
    <div className="pt-20" data-testid="collections-page">
      <div className="px-5 md:px-10 pt-16 pb-14 max-w-[1600px] mx-auto">
        <FadeUp><p className="overline text-gold-deep mb-4">Explore</p></FadeUp>
        <h1 className="font-serif text-6xl md:text-8xl tracking-tight leading-none">
          <RevealMaskScroll>Collections</RevealMaskScroll>
        </h1>
        <p className="mt-6 max-w-xl text-ink-soft">Twelve signature silhouettes, each a study in craft and restraint. Choose your entry point.</p>
      </div>

      <div className="px-5 md:px-10 max-w-[1600px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-5 pb-24">
        {categories.map((c, i) => (
          <FadeUp key={c.slug} delay={(i % 2) * 0.08}>
            <Link to={`/shop?category=${c.slug}`} className="group relative block aspect-[16/10] overflow-hidden bg-[#efece6]" data-testid={`collection-${c.slug}`}>
              <img src={c.image} alt={c.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/70 to-transparent" />
              <div className="absolute bottom-0 left-0 p-8">
                <p className="overline text-gold mb-2">0{i + 1}</p>
                <h2 className="font-serif text-4xl md:text-5xl text-ivory tracking-tight">{c.name}</h2>
                <p className="text-ivory/70 text-sm mt-2 max-w-sm">{c.description}</p>
                <span className="mt-4 flex items-center gap-2 overline text-ivory opacity-0 group-hover:opacity-100 transition-opacity">Shop now <ArrowRight size={13} /></span>
              </div>
            </Link>
          </FadeUp>
        ))}
      </div>

      <div className="bg-ink text-ivory py-24">
        <div className="px-5 md:px-10 max-w-[1600px] mx-auto">
          <p className="overline text-gold mb-10 text-center">Shop by Occasion</p>
          <div className="grid grid-cols-2 md:grid-cols-6 gap-4">
            {occasions.map((o) => (
              <Link key={o.slug} to={`/shop?occasion=${o.name}`} className="group relative aspect-[3/4] overflow-hidden">
                <img src={o.image} alt={o.name} loading="lazy" className="h-full w-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-ink/40" />
                <span className="absolute inset-x-0 bottom-4 text-center font-serif text-xl">{o.name}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
